export default __webpack_public_path__ + "assets/HelpiTuto2.png";